module.exports = "/_next/static/images/014129767d97218526e272460dd9f0ca-payment_bills_list.png.webp";